import { render, staticRenderFns } from "./AiCaseGenerator.vue?vue&type=template&id=0ca8e008"
import script from "./AiCaseGenerator.vue?vue&type=script&lang=js"
export * from "./AiCaseGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports